import { profileRoutes } from '../../../utils/consts/routes';
const urlLocation = window.location.host;
export const footerObj = {
  who: [
    {
      name: `${
        urlLocation.includes('tripord') ? 'aboutus.tripord' : 'aboutus.tripsi'
      }`,
      link: '/about',
    },
    // { name: "contactus", link: "/contact" },
    {
      name: 'footer.customer',
      value: urlLocation.includes('tripord')
        ? 'aboutus.canadaphone'
        : 'aboutus.iranphone',
    },
  ],
  rules: [
    { name: 'footer.privacy', link: '/privacy' },
    { name: 'footer.claim', link: '/claim' },
    {
      name: 'footer.rules',
      link: `${profileRoutes.rules}?section="domestic_fine"`,
    },
  ],
  supports: [
    { name: 'footer.tourismMagazine' },
    { name: 'footer.customerClub' },
    { name: 'footer.ticketGuide' },
  ],
};
export const customEnamad = {
  'tripsi.ir': {
    link: 'https://trustseal.enamad.ir/?id=307763&code=DPVNteZjwOo6xM5cG84m',
    // name: 'https://trustseal.enamad.ir/logo.aspx',
    name: 'namad.png',
    id: 'DPVNteZjwOo6xM5cG84m',
    isonline: false,
  },
  localhost: {
    link: 'https://trustseal.enamad.ir/?id=307763&code=DPVNteZjwOo6xM5cG84m',
    name: 'namad.png',
    id: 'DPVNteZjwOo6xM5cG84m',
    isonline: false,
  },
  '77.104.103.150:4000': {
    link: 'https://trustseal.enamad.ir/?id=307763&code=DPVNteZjwOo6xM5cG84m',
    name: 'namad.png',
    id: 'DPVNteZjwOo6xM5cG84m',
    isonline: false,
  },
};
export const footerLogo = [
  {
    name: 'miras.png',
    link: 'https://www.mcth.ir/',
    imgClass: 'p-2',
  },
  {
    ...customEnamad[urlLocation],
    name: 'namad.png',
    imgClass: 'p-0',
  },
  { name: 'kasb.png', link: 'https://ecunion.ir', imgClass: 'p-2' },
  {
    name: 'state-airline.317506d.svg',
    link: 'https://caa.gov.ir/',
    imgClass: 'p-2',
  },
  {
    name: 'aira-ticket-price.png',
    link: 'http://www.aira.ir/',
    imgClass: 'p-2',
  },
  {
    name: 'passenger-rights.9eea7f0.svg',
    link: 'https://farasa.cao.ir/sysworkflow/fa/modern/3810212626028ab03488017019616799/6464336316028ab04e3c618028352200.php',
    imgClass: 'p-2',
  },
  {
    name: 'samandehi.png',
    link: 'https://logo.samandehi.ir/Verify.aspx?id=321202&p=xlaouiwkrfthuiwkobpduiwk',
    imgClass: 'p-2',
  },
];
